import { Col } from 'components/Col';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto, PrincipioValor } from 'models/projeto';
import { useContext, useEffect, useLayoutEffect, useMemo } from 'react';
import { getOptionsFromParams } from 'utils/DropdownUtils';
import languageValues from 'utils/LanguageUtils';
import SnackbarUtils from 'utils/SnackbarUtils';

const language = languageValues.inputs.idPrincipiosValores;
export default function PrincipiosValores() {
  const { state, dispatch, validator, loadPrincipiosValores } =
    useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'idPrincipiosValores',
        etapa: EtapaProjeto.indiceFinal,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  useEffect(() => {
    loadPrincipiosValores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useLayoutEffect(() => {
    if (
      !state.projeto.idPrincipiosValores?.length ||
      !state.projeto.idPrincipiosValores.includes(PrincipioValor.Cooperacao) ||
      !state.projeto.idPrincipiosValores.includes(PrincipioValor.Cidadania)
    ) {
      dispatch({
        type: 'setProjeto',
        payload: {
          idPrincipiosValores: [
            PrincipioValor.Cooperacao,
            PrincipioValor.Cidadania,
            ...(state.projeto.idPrincipiosValores || []).filter(
              (p) =>
                ![PrincipioValor.Cooperacao, PrincipioValor.Cidadania].includes(
                  p
                )
            ),
          ],
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = useMemo(() => {
    return state.options.principiosValores.options
      ? getOptionsFromParams(
          state.options.principiosValores.options,
          'id',
          (i) => i.nome.toUpperCase()
        )
      : [];
  }, [state.options.principiosValores.options]);

  return (
    <Row>
      <Col>
        <NewAutoCompleteField
          label={language.label(state.projeto.flgInfantil)}
          placeholder={language.placeholder}
          loading={state.options.principiosValores.loading}
          loadingMessage={language.loading}
          options={options}
          value={state.projeto.idPrincipiosValores ?? []}
          multiple
          onChange={(option: { value: PrincipioValor; label: string }[]) => {
            const mapped = option ? option.map((o) => o.value) : [];
            if (
              !mapped.includes(PrincipioValor.Cooperacao) ||
              !mapped.includes(PrincipioValor.Cidadania)
            ) {
              SnackbarUtils.error(
                languageValues.toasts.error.principioValorBase
              );
              dispatch({
                type: 'setProjeto',
                payload: {
                  idPrincipiosValores: [
                    PrincipioValor.Cooperacao,
                    PrincipioValor.Cidadania,
                    ...mapped.filter(
                      (p) =>
                        ![
                          PrincipioValor.Cooperacao,
                          PrincipioValor.Cidadania,
                        ].includes(p)
                    ),
                  ],
                },
              });
              return;
            }
            dispatch({
              type: 'setProjeto',
              payload: {
                idPrincipiosValores: mapped,
              },
            });
          }}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
